import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { FooterModule } from '@vueling-ng/vy-ds/src/lib/components/composed/footer';
import { HeaderModule } from '@vueling-ng/vy-ds/src/lib/components/composed/header';
import { AvatarModule } from '@vueling-ng/vy-ds/src/lib/components/globals/avatar';
import { AvatarNameModule } from '@vueling-ng/vy-ds/src/lib/components/globals/avatar-name';
import { ButtonModule } from '@vueling-ng/vy-ds/src/lib/components/globals/button';
import { IconModule } from '@vueling-ng/vy-ds/src/lib/components/globals/icon';
import { IconTextModule } from '@vueling-ng/vy-ds/src/lib/components/globals/icon-text';
import { ListDropdownModule } from '@vueling-ng/vy-ds/src/lib/components/globals/list-dropdown';
import { MenuVerticalComponent } from '@vueling-ng/vy-ds/src/lib/components/globals/menu-vertical';
import { TextLinkModule } from '@vueling-ng/vy-ds/src/lib/components/globals/text-link';
import { FooterComponent } from './footer/footer.component';
import { AccountManagementComponent } from './header/components/account-management/account-management.component';
import { LangCurrencySelectorComponent } from './header/components/lang-currency-selector/lang-currency-selector.component';
import { HeaderComponent } from './header/header.component';

@NgModule({
  declarations: [HeaderComponent, FooterComponent, LangCurrencySelectorComponent, AccountManagementComponent],
  imports: [
    HeaderModule,
    FooterModule,
    ListDropdownModule,
    ButtonModule,
    CommonModule,
    TranslateModule,
    AvatarModule,
    RouterModule,
    IconTextModule,
    IconModule,
    AvatarNameModule,
    MenuVerticalComponent,
    TextLinkModule
  ],
  exports: [HeaderComponent, FooterComponent, LangCurrencySelectorComponent, AccountManagementComponent]
})
export class CommonComponentsModule {}
